import { asyncStart } from '../../../common';

export const GET_CLASSLINK_SETTINGS = 'Integrations.getClasslinkSettings';
export const getClasslinkSettings = () => (dispatch) => {
  dispatch(asyncStart(GET_CLASSLINK_SETTINGS));
  dispatch({ type: GET_CLASSLINK_SETTINGS });
};

export const SAVE_CLASSLINK_SETTINGS = 'Integrations.saveClasslinkSettings';

export const CLASSLINK_STATE_CHANGED = 'Integrations.classlinkStateChanged';
export const classlinkStateChanged = (state) => ({ type: CLASSLINK_STATE_CHANGED, state });
